import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AppSettings } from '../../app.settings';
import { Settings } from '../../app.settings.model';
import { MenuService } from '../menu/menu.service';
import { CommonService } from "../../../shared/common/common.service";
import { AuthService } from "../../../auth/auth.service";
import { Router } from "@angular/router";
import { LocalStorageKeys } from '../../constants/localStorageKeys.enum';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [MenuService],
  animations: [
    trigger('showInfo', [
      state('1', style({ transform: 'rotate(180deg)' })),
      state('0', style({ transform: 'rotate(0deg)' })),
      transition('1 => 0', animate('400ms')),
      transition('0 => 1', animate('400ms'))
    ])
  ]
})
export class HeaderComponent implements OnInit {
  public showHorizontalMenu = true;
  public showInfoContent = false;
  public settings: Settings;
  public CurrentUserName: string;
  showAccessTokenTimer = false;
  showRequestQueueingTest = false;


  constructor(
    public appSettings: AppSettings,
    public menuService: MenuService,
    private commonService: CommonService,
    private authService: AuthService,
    private route: Router) {
    this.settings = this.appSettings.settings;

    this.commonService.userrole.subscribe((data: any) => {
      this.CurrentUserName = data['FirstName'] + ' ' + data['LastName'];
    })
  }

  ngOnInit() {
    this.CurrentUserName = this.authService.currentUserName;

    const showTimerLsValue = localStorage.getItem(LocalStorageKeys.SHOW_ACCESS_TOKEN_EXPIRATION);
    this.showAccessTokenTimer = !!showTimerLsValue;

    const showRequestQueueLsValue = localStorage.getItem(LocalStorageKeys.SHOW_REQUEST_QUEUE_TEST_TOGGLE);
    this.showRequestQueueingTest = !!showRequestQueueLsValue;
  }


  public closeSubMenus() {
    const menu = document.querySelector("#menu0");
    if (menu) {
      for (let i = 0; i < menu.children.length; i++) {
        const child = menu.children[i].children[1];
        if (child) {
          if (child.classList.contains('show')) {
            child.classList.remove('show');
            menu.children[i].children[0].classList.add('collapsed');
          }
        }
      }
    }
  }

  @HostListener('window:resize')
  public onWindowResize(): void {
    if (window.innerWidth <= 768) {
      this.showHorizontalMenu = false;
    }
    else {
      this.showHorizontalMenu = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/header/header.component.ts